(() => {
  'use strict';
  const root = document.querySelector('[data-tko-root]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  // Page-only chrome adaptation: no shared theme file is changed.
  const announcements = ['Tekko One · Retrouvez le plaisir de jouer', 'Livraison suivie', 'Garantie commerciale 1 an'];
  document.querySelectorAll('.gs-announcement-section .gs-bar__label').forEach((el, i) => el.textContent = announcements[i % announcements.length]);
  const mobileAnnouncement = document.querySelector('.gs-announcement-section .gs-bar__mobile');
  if (mobileAnnouncement) mobileAnnouncement.textContent = 'Tekko One · Jouez partout, même sans Wi-Fi';
  document.querySelectorAll('header a[href*="anarilla-hydra-brush"], footer a[href*="anarilla-hydra-brush"]').forEach(link => {
    const hash = new URL(link.href).hash;
    link.href = hash === '#reviews' ? '#tko-reviews' : hash === '#faq' ? '#tko-faq' : '#tko-offers';
    link.textContent = hash === '#reviews' ? 'Avis' : hash === '#faq' ? 'FAQ' : 'Tekko One';
  });
  document.querySelectorAll('footer .gsft-col-title').forEach(el => { if (/Hydra|Brusheo/i.test(el.textContent)) el.textContent = 'Tekko One'; });
  const copyright = document.querySelector('footer .gsft-copy');
  if (copyright) copyright.textContent = copyright.textContent.replace('Anarilla', 'Lumicold');
  document.querySelectorAll('footer a[href="/pages/faq"]').forEach(el => el.href = '#tko-faq');
  document.body.classList.add('tko-chrome-ready');
  const $ = s => root.querySelector(s);
  const $$ = s => [...root.querySelectorAll(s)];
  const product = JSON.parse($('[data-tko-product]').textContent);
  const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: product.currency }).format(cents / 100);
  const form = $('[data-tko-form]'), qty = $('[data-tko-qty]');
  const slides = $$('[data-tko-slide]'), thumbs = $$('[data-tko-thumb]');
  let selected, busy = false, index = 0;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const behavior = () => reduced.matches ? 'instant' : 'smooth';
  const imageReady = new WeakMap();
  let galleryRequest = 0;
  function prepareSlide(next, priority = 'low') {
    const slide = slides[(next + slides.length) % slides.length];
    const img = slide.querySelector('img');
    if (!img) return Promise.resolve(); // Do not pre-download videos in the background.
    img.decoding = 'async';
    img.fetchPriority = priority;
    img.loading = 'eager'; // Hidden lazy slides otherwise wait until the click to fetch.
    if (imageReady.has(img)) return imageReady.get(img);
    const loaded = img.complete && img.naturalWidth > 0 ? Promise.resolve() : new Promise((resolve, reject) => {
      const done = () => { cleanup(); resolve(); };
      const fail = () => { cleanup(); reject(new Error('Image unavailable')); };
      const cleanup = () => { img.removeEventListener('load', done); img.removeEventListener('error', fail); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', fail, { once: true });
    });
    const ready = loaded.then(() => img.decode ? img.decode().catch(() => {}) : undefined);
    imageReady.set(img, ready);
    ready.catch(() => imageReady.delete(img));
    return ready;
  }
  function warmNeighbours(center) {
    [center + 1, center + 2, center - 1].forEach(i => prepareSlide(i).catch(() => {}));
  }
  async function showSlide(next) {
    index = (next + slides.length) % slides.length;
    const target = index, request = ++galleryRequest, stage = $('[data-tko-stage]');
    stage.setAttribute('aria-busy', 'true');
    try { await prepareSlide(target, 'high'); }
    catch {
      if (request !== galleryRequest) return;
      index = slides.findIndex(slide => !slide.hidden);
      stage.setAttribute('aria-busy', 'false');
      $('[data-tko-gallery-status]').textContent = 'Ce visuel ne se charge pas. Réessayez avec les flèches.';
      return;
    }
    if (request !== galleryRequest) return;
    $('[data-tko-gallery-status]').textContent = '';
    slides.forEach((slide, i) => {
      slide.hidden = i !== target;
      if (i !== target) slide.querySelectorAll('video').forEach(v => v.pause());
    });
    stage.setAttribute('aria-busy', 'false');
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === target)));
    $('[data-tko-count]').textContent = `${target + 1} / ${slides.length}`;
    const rail = thumbs[target].parentElement, thumb = thumbs[target];
    rail.scrollTo({ left: thumb.offsetLeft - rail.offsetLeft - (rail.clientWidth - thumb.clientWidth) / 2, behavior: behavior() });
    warmNeighbours(target);
  }
  $('[data-tko-prev]').addEventListener('click', () => showSlide(index - 1));
  $('[data-tko-next]').addEventListener('click', () => showSlide(index + 1));
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showSlide(i)));
  thumbs.forEach((thumb, i) => {
    ['pointerenter', 'focus', 'touchstart'].forEach(event => thumb.addEventListener(event, () => prepareSlide(i).catch(() => {}), { passive: true }));
  });
  $('[data-tko-next]').addEventListener('pointerenter', () => prepareSlide(index + 1).catch(() => {}));
  $('[data-tko-prev]').addEventListener('pointerenter', () => prepareSlide(index - 1).catch(() => {}));
  $('[data-tko-stage]').addEventListener('keydown', e => {
    if (e.target.closest('video')) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); showSlide(index + (e.key === 'ArrowRight' ? 1 : -1)); }
  });
  let touch;
  $('[data-tko-stage]').addEventListener('touchstart', e => {
    touch = e.target.closest('video') ? null : { x: e.touches[0].clientX, y: e.touches[0].clientY };
  }, { passive: true });
  $('[data-tko-stage]').addEventListener('touchend', e => {
    if (!touch) return;
    const dx = e.changedTouches[0].clientX - touch.x, dy = e.changedTouches[0].clientY - touch.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) showSlide(index + (dx < 0 ? 1 : -1));
    touch = null;
  }, { passive: true });
  function quantity() { const n = Math.max(1, Math.min(10, Math.floor(Number(qty.value) || 1))); qty.value = n; return n; }
  const isDuo = () => selected?.capacity.startsWith('128');
  function sync(changeImage = false, changeUrl = false) {
    const color = $('[name="tko-color"]:checked')?.value, capacity = $('[name="tko-capacity"]:checked')?.value;
    selected = product.variants.find(v => v.color === color && v.capacity === capacity);
    if (!selected) return;
    const n = quantity();
    const duo = isDuo();
    $('[data-tko-submit-qty]').value = n * (duo ? 2 : 1);
    $('[data-tko-pack-summary]').hidden = !duo;
    $('[data-tko-pack-summary]').textContent = `${n} offre${n > 1 ? 's' : ''} duo · ${n * 2} consoles 128 Go / 40 000 jeux · ${n} offerte${n > 1 ? 's' : ''} · même couleur`;
    $('[data-tko-variant]').value = selected.id;
    $('[data-tko-color-label]').textContent = selected.color;
    $('[data-tko-price]').textContent = money(selected.price);
    const compare = $('[data-tko-compare]');
    compare.hidden = !duo && selected.compare <= selected.price; compare.textContent = money(duo ? selected.price * 2 : selected.compare);
    ['atc-price', 'sticky-price'].forEach(key => $(`[data-tko-${key}]`).textContent = money(selected.price * n));
    $('[data-tko-sticky-meta]').textContent = duo ? `${n * 2} consoles · ${selected.color} · 128 Go` : `${selected.color} · ${selected.capacity}`;
    $('[data-tko-pair-value]').textContent = money(product.variants.find(v => v.color === color && v.capacity.startsWith('128')).price * 2);
    $$('[data-tko-offer-price]').forEach(el => { const v = product.variants.find(v => v.color === color && v.capacity === el.dataset.tkoOfferPrice); if (v) el.textContent = money(v.price); });
    $$('[data-tko-atc], [data-tko-sticky-atc]').forEach(el => { el.disabled = busy || !selected.available; el.setAttribute('aria-busy', String(busy)); });
    $('[data-tko-atc-label]').textContent = busy ? 'Ajout en cours…' : selected.available ? 'Ajouter au panier' : 'Indisponible';
    $('[data-tko-minus]').disabled = busy || n <= 1;
    $('[data-tko-plus]').disabled = busy || n >= 10;
    qty.disabled = busy;
    $$('[name="tko-color"], [name="tko-capacity"]').forEach(el => el.disabled = busy);
    if (changeImage && selected.mediaId) { const i = slides.findIndex(el => el.dataset.mediaId === String(selected.mediaId)); if (i >= 0) showSlide(i); }
    if (changeUrl) { const url = new URL(location.href); url.searchParams.set('variant', selected.id); history.replaceState({}, '', url); }
  }
  $$('[name="tko-color"], [name="tko-capacity"]').forEach(el => el.addEventListener('change', () => sync(el.name === 'tko-color', true)));
  $('[data-tko-minus]').addEventListener('click', () => { qty.value = quantity() - 1; sync(); });
  $('[data-tko-plus]').addEventListener('click', () => { qty.value = quantity() + 1; sync(); });
  qty.addEventListener('change', () => sync());
  form.addEventListener('submit', e => {
    e.preventDefault(); e.stopImmediatePropagation();
    if (busy || !selected?.available) return;
    const item = { id: selected.id, quantity: quantity() * (isDuo() ? 2 : 1) }, error = $('[data-tko-error]');
    busy = true; error.hidden = true; sync();
    document.dispatchEvent(new CustomEvent('cart:add', { detail: {
      items: [item], source: 'tekko-one-lumicold',
      onSuccess: () => { busy = false; sync(); },
      onError: () => { busy = false; sync(); error.textContent = 'L’ajout n’a pas abouti. Vérifiez votre connexion et réessayez.'; error.hidden = false; }
    } }));
  }, true);
  $('[data-tko-sticky-atc]').addEventListener('click', () => form.requestSubmit());
  sync(true);

  $$('[data-tko-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-tko-track]'), cards = [...track.children];
    const prev = carousel.querySelector('[data-tko-carousel-prev]'), next = carousel.querySelector('[data-tko-carousel-next]');
    const count = carousel.querySelector('[data-tko-carousel-count]');
    const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
    function update() {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      prev.disabled = track.scrollLeft < 3; next.disabled = track.scrollLeft > max - 3;
      const first = Math.round(track.scrollLeft / step()) + 1;
      const last = Math.min(cards.length, Math.floor((track.scrollLeft + track.clientWidth + 3) / step()));
      count.textContent = `${first}${last > first ? '–' + last : ''} / ${cards.length}`;
    }
    function move(direction) {
      const target = Math.round(track.scrollLeft / step()) * step() + direction * step();
      track.scrollTo({ left: Math.max(0, Math.min(track.scrollWidth - track.clientWidth, target)), behavior: behavior() });
    }
    prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); } });
    new ResizeObserver(update).observe(track); update();
  });

  const search = $('[data-tko-game-search]'), results = $('[data-tko-game-results]');
  let gamePromise, gameTimer, searchSequence = 0;
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  async function searchGames() {
    const sequence = ++searchSequence, query = normalize(search.value);
    results.replaceChildren();
    if (query.length < 2) { results.textContent = 'Saisissez au moins 2 caractères pour rechercher dans le catalogue.'; return; }
    results.textContent = 'Recherche dans le catalogue…';
    try {
      if (!gamePromise) gamePromise = fetch(search.dataset.url).then(r => { if (!r.ok) throw Error('Catalogue indisponible'); return r.json(); });
      const games = await gamePromise;
      if (sequence !== searchSequence) return;
      const found = games.filter(g => g.b && query.split(' ').every(word => normalize(g.n).includes(word)));
      results.replaceChildren();
      if (!found.length) { results.textContent = 'Aucun titre trouvé sous ce nom. Contactez-nous pour vérifier ce jeu avant de commander.'; return; }
      const heading = document.createElement('p'); heading.textContent = `${found.length} titre${found.length > 1 ? 's' : ''} trouvé${found.length > 1 ? 's' : ''}${found.length > 40 ? ' · 40 premiers affichés' : ''}`; results.append(heading);
      found.slice(0, 40).forEach(g => { const row = document.createElement('div'), name = document.createElement('strong'), badge = document.createElement('small'); row.className = 'tko-search-result'; name.textContent = g.n; badge.textContent = g.a ? '64 Go et 128 Go' : '128 Go uniquement'; row.append(name, badge); results.append(row); });
    } catch { gamePromise = null; if (sequence === searchSequence) results.textContent = 'Le catalogue ne se charge pas pour le moment. Réessayez ou contactez-nous.'; }
  }
  search.addEventListener('input', () => { clearTimeout(gameTimer); gameTimer = setTimeout(searchGames, 180); });
  search.addEventListener('focus', searchGames);
  const sticky = $('[data-tko-sticky]'), mainAtc = $('[data-tko-atc]'), drawer = document.getElementById('gscdDrawer');
  function updateSticky() { sticky.hidden = innerWidth >= 950 || mainAtc.getBoundingClientRect().bottom >= 0 || !!drawer?.classList.contains('active'); }
  new IntersectionObserver(updateSticky).observe(mainAtc);
  if (drawer) new MutationObserver(updateSticky).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', updateSticky, { passive: true }); updateSticky();
})();
